const FalklandIslandsSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111409)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C0 20.0048 20 0.0021875 20 0C31.0456 0 40 8.95437 40 20Z"
        fill="#0052B4"
      />
      <path
        d="M19.9468 19.9998H20.0003C20.0003 19.9818 20.0003 19.9643 20.0003 19.9463C19.9825 19.9642 19.9647 19.982 19.9468 19.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 10.4348C20 6.91563 20 4.60977 20 0H19.9966C8.9525 0.001875 0 8.95539 0 20H10.4348V14.1241L16.3107 20H19.9466L20.0001 19.9465C20.0001 18.5991 20.0001 17.3968 20.0001 16.3108L14.1241 10.4348H20Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.1181 2.6084C6.99004 4.38957 4.38957 6.99004 2.6084 10.1181V19.9997H7.82582V7.82598V7.82582H19.9997C19.9997 6.18027 19.9997 4.61262 19.9997 2.6084H10.1181Z"
        fill="#D80027"
      />
      <path
        d="M19.9992 17.5403L12.8935 10.4346H10.4341V10.4347L19.9991 19.9997H19.9992C19.9992 19.9997 19.9992 18.3039 19.9992 17.5403Z"
        fill="#D80027"
      />
      <path
        d="M32.1736 23.4785V24.348H25.2171V23.4785H22.6084V26.9567H24.3475V27.8263H33.0432V26.9567H34.7823V23.4785H32.1736Z"
        fill="#FFDA44"
      />
      <path
        d="M22.6084 10.4346V19.9998C22.6084 24.6591 28.6954 26.0868 28.6954 26.0868C28.6954 26.0868 34.7823 24.6591 34.7823 19.9998V10.4346H22.6084Z"
        fill="#338AF3"
      />
      <path
        d="M28.695 17.5693C27.1733 17.5693 27.1733 18.9607 25.6517 18.9607C24.13 18.9607 24.13 17.5693 22.6084 17.5693V20.0041C24.13 20.0041 24.13 21.3954 25.6517 21.3954C27.1733 21.3954 27.1733 20.0041 28.695 20.0041C30.2168 20.0041 30.2168 21.3954 31.7386 21.3954C33.2605 21.3954 33.2604 20.0041 34.7823 20.0041V17.5693C33.2605 17.5693 33.2605 18.9607 31.7386 18.9607C30.2168 18.9607 30.2168 17.5693 28.695 17.5693Z"
        fill="#F3F3F3"
      />
      <path
        d="M28.695 12.6953C27.1733 12.6953 27.1733 14.0866 25.6517 14.0866C24.13 14.0866 24.13 12.6953 22.6084 12.6953V15.1301C24.13 15.1301 24.13 16.5214 25.6517 16.5214C27.1733 16.5214 27.1733 15.1301 28.695 15.1301C30.2168 15.1301 30.2168 16.5214 31.7386 16.5214C33.2605 16.5214 33.2604 15.1301 34.7823 15.1301V12.6953C33.2605 12.6953 33.2605 14.0866 31.7386 14.0866C30.2168 14.0866 30.2168 12.6953 28.695 12.6953Z"
        fill="#F3F3F3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111409">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default FalklandIslandsSvg;
